<template>
  <div class="huasuhui">
    <el-carousel arrow="never" class="banner" indicator-position="none">
      <el-carousel-item v-for="item in advertList" :key="item.id">
        <a v-if="item.linkUrl" :href="item.linkUrl" target="_blank">
          <el-image :src="item.imageUrl" fit="cover"></el-image>
        </a>
        <el-image v-else :src="item.imageUrl" fit="cover"></el-image>
      </el-carousel-item>
    </el-carousel>

    <div class="wrap">
      <div class="tab-img">
        <router-link class="tab-img-a" to="/datacenter/peasants">
          <img class="img_0" src="./images/tab_zhongnongwang_0.png" />
          <img class="img_1" src="./images/tab_zhongnongwang_1.png" />
        </router-link>
        <router-link class="tab-img-a" to="/datacenter/zsteel">
          <img class="img_0" src="./images/tab_zhuoganlian_0.png" />
          <img class="img_1" src="./images/tab_zhuoganlian_1.png" />
        </router-link>
        <a class="tab-img-a">
          <img class="tab-huasuhui" src="./images/tab_huasuhui_1.png" />
        </a>
      </div>
      <div class="tab-header">
        <div class="tab-title">
          <div class="tab-title-pinlei">品类：</div>

          <div
            tabindex="1"
            v-for="(item, index) in cateList"
            :key="index"
            :class="[currentIndex === index ? 'tabItem active' : 'tabItem']"
            @click="clickCate(item, index)"
          >
            {{ item.categoryName }}
          </div>
        </div>

        <div class="tab-content">
          <div class="tab-content-header">商品列表</div>
          <img src="@/assets/images/noData.png" class="no_data" v-if="noData" />
          <div class="tab-content-box" v-for="(item, index) in goodsList" :key="index">
            <div class="box-left">
              <img class="tab-content-left" src="@/assets/images/datacenter/img_huasuhui.png" />
              <div class="content-main">
                <div class="main-header">{{ item.goodsName || '面议' }}</div>
                <div class="main-sub">
                  <span>{{ item.categoryName || '面议' }}</span>
                  <div class="main-sub-line">|</div>
                  <span>{{ item.specifications || '面议' }}</span>
                </div>
                <div class="main-footer">
                  <img class="main-footer-icon" src="./images/icon_changjia@2x.png" />
                  {{ item.brand || '面议' }}
                </div>
              </div>
            </div>
            <div class="box-right">
              <div>价格面议</div>

              <div class="box-right-buy" @click="dialogVisible = true">
                <img class="box-right-buy-icon" src="./images/icon_lainxi@2x.png" />
                <span>联系购买</span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <el-dialog
        title="请联系我们"
        :visible.sync="dialogVisible"
        width="640px"
        top="20vh"
        :close-on-click-modal="false"
        :append-to-body="true"
        :lock-scroll="false"
      >
        <div class="dialog-content">
          <img class="dialog-img" src="./images/icon_tel@2x.png" />
          <span class="dialog-title">业务合作电话</span>
        </div>
        <div class="dialog-tel">021-31778058</div>
        <div class="dialog-line"></div>
        <div class="dialog-content">
          <img class="dialog-img" src="./images/icon_web@2x.png" />
          <span class="dialog-title">官网</span>
        </div>
        <a class="dialog-tel" target="_blank" href="https://www.huasuhui.com/">www.huasuhui.com</a>
        <span slot="footer" class="dialog-footer">
          <el-button type="primary" @click="dialogVisible = false">确 定</el-button>
        </span>
      </el-dialog>
      <div v-if="total > 10" style="text-align: center">
        <el-pagination
          v-if="total"
          class="changeEle"
          background
          layout="prev, pager, next"
          :current-page="listParams.currentPage"
          :total="total"
          :page-size="listParams.pageSize"
          @current-change="onCurChange"
        >
        </el-pagination>
      </div>
      <MessageBoard v-if="showMessageBoard" :isShow="showMessageBoard" @submit="onSubmit" @cancel="onCancel">
      </MessageBoard>
    </div>
  </div>
</template>

<script>
import { getBanner, getHwOrderList, intentionInfoAdd, hshGoods, hshCate } from '@/api';
import MessageBoard from '@/components/MessageBoard';
export default {
  components: {
    MessageBoard,
  },
  data() {
    return {
      orderParam: {
        total: 0,
        page: 1,
        rows: 20,
        pn: '', // 品名
        sc: '', // 型号
      },
      total: 0,
      listParams: {
        currentPage: 1,
        pageSize: 10,
        categoryCode: '',
        marketCode: '',
      },
      cateList: [
        {
          categoryCode: '',
          categoryName: '全部',
        },
      ],
      goodsList: [],
      currentIndex: 0,
      dialogVisible: false,
      orderList: [],
      orderData: {}, // 订单数据
      boardData: {}, // 留言数据
      advertList: [],
      showMessageBoard: false,
      loading: true,
      noData: false,
    };
  },

  created() {
    this.getBannerList();
    //this.getOrderList();
    this.getCate();
    this.getList();
  },
  methods: {
    async getCate() {
      const ret = await hshCate({
        marketCode: '',
      });
      if (ret.code === 100000) {
        ret.data.forEach((item) => {
          this.cateList.push(item);
        });
      }
    },
    async getList() {
      this.loading = true;
      const ret = await hshGoods(this.listParams);
      this.loading = false;
      this.total = ret.data.total;
      if (ret.code === 100000) {
        this.goodsList = ret.data.rows;
        this.noData = this.goodsList.length ? false : true;
      }
    },

    clickCate(item, index) {
      this.currentIndex = index;
      this.listParams.categoryCode = item.categoryCode;
      this.listParams.currentPage = 1;
      this.getList();
    },

    onCurChange(curPage) {
      this.listParams.currentPage = curPage;
      this.getList();
      document.body.scrollTop = document.documentElement.scrollTop = 560;
    },
    onSearch() {
      this.orderParam.page = 1;
      this.getOrderList();
    },
    onSubmit(val) {
      this.boardData = val;
      this.intentionInfoAdd();
    },
    onCancel() {
      this.showMessageBoard = false;
    },
    onBuy(order) {
      this.showMessageBoard = true;
      this.orderData = order;
    },
    getBannerList() {
      let postData = { page: 1, path: 'platform', uc_to: '' };
      getBanner(postData).then((res) => {
        if (res.status) {
          let { content } = res.data;
          if (Array.isArray(content) && content.length) {
            let [, , , banner] = content[0];
            if (banner && typeof banner.data === 'object') {
              let { advertList } = banner.data;
              this.advertList = Array.isArray(advertList) ? advertList : [];
            }
          }
        } else {
          this.$message.error(res.errorMsg);
        }
      });
    },
    getOrderList() {
      let postData = { ...this.orderParam };
      getHwOrderList(postData).then((res) => {
        if (res.status) {
          let { total, rows } = res.data;
          // 总页数
          this.orderParam.total = total;
          // 拼接数据
          this.orderList = rows;
        } else {
          this.$message.error(res.errorMsg);
        }
      });
    },
    intentionInfoAdd() {
      /**
       * let postData = {
       *   cn: '联系人',
       *   ph: '联系人手机号码',
       *   pf: '平台1卓钢链 2中农 3化塑汇',
       *   pc: '商品code',
       *   pn: '名称（根据平台不同，名称由各个平台的商品不同属性组合而成，逗号拼接）',
       *   mk: '备注',
       * };
       */
      let { name: cn, tel: ph, remark: mk = '' } = this.boardData;
      let { prodCode: pc = '', specification = '', prodName = '' } = this.orderData;
      let postData = { cn, ph, pf: 3, pc, pn: prodName + ', ' + specification, mk };
      intentionInfoAdd(postData).then((res) => {
        if (res.status) {
          this.$message.success('咨询意向单提交成功');
          this.showMessageBoard = false;
        } else {
          this.$message.error(res.errorMsg);
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.huasuhui {
  width: 100%;
  overflow-x: hidden;
  .pagination {
    padding: 20px 0 30px 0;
    text-align: center;
  }
  .totals {
    margin-top: 20px;
    margin-bottom: 30px;
  }
  .banner {
    width: 100%;
    min-width: 1180px;
    height: 500px;
    text-align: center;

    ::v-deep .el-carousel__container {
      width: 100%;
      height: 100%;
    }

    a {
      display: block;
      height: 100%;
    }

    .el-image {
      width: 100%;
      height: 500px;
    }
  }

  .wrap {
    box-sizing: border-box;
    width: 1180px;
    margin: 0 auto;
    margin-top: 24px;
  }

  .breadcrumb {
    height: 60px;
    line-height: 60px;
    background: #fff;
    border-bottom: 1px solid #eaeaea;

    ::v-deep .el-breadcrumb__inner {
      font-weight: bold;
    }
  }

  .form-inline {
    padding: 20px 0 20px 0;
  }

  .title {
    height: 40px;
    margin-bottom: 10px;
    overflow: hidden;
    font-size: 22px;
    line-height: 40px;
    color: #333;
    border-bottom: 1px solid #eaeaea;

    .title-left {
      font-weight: bold;
    }

    .title-right {
      float: right;
      font-size: 14px;
      font-weight: 400;
      color: #0076ff;
    }
  }

  .btn-search {
    width: 120px;
    border-radius: 0 2px 2px 0;
  }

  .btn-buy {
    font-size: 14px;
    font-weight: 400;
    color: #0076ff;
    cursor: pointer;
  }

  .changeEle {
    padding: 20px 0 30px 0;
    text-align: center;
  }

  .tab-img {
    display: flex;

    .tab-img-a {
      display: flex;
      border: 1.5px dotted #ececec;
      margin-right: 8px;
      cursor: pointer;

      .img_1 {
        display: none;
      }
    }

    .tab-img-a:focus {
      border: 1.5px dotted #7f97ee;
      box-shadow: 0px 2px 6px 0px rgba(127, 151, 238, 0.5);
    }

    .tab-img-a:hover {
      border: 1.5px dotted #7f97ee;
      box-shadow: 0px 2px 6px 0px rgba(127, 151, 238, 0.5);
      cursor: pointer;
    }

    .tab-img-a:focus .img_1,
    .tab-img-a:hover .img_1 {
      display: block;
    }

    .tab-img-a:hover .img_0 {
      display: none;
    }

    .tab-img-a:focus .img_0 {
      display: none;
    }

    .tab-huasuhui {
      border: 1.5px dotted #7f97ee;
      box-shadow: 0px 2px 6px 0px rgba(127, 151, 238, 0.5);
    }
  }

  .tab-header {
    display: flex;
    justify-content: space-evenly;
    flex-direction: column;
    font-size: 16px;
    cursor: default;
    padding-top: 21px;

    .tab-title {
      display: flex;
      align-content: center;
      padding-bottom: 37px;
      border-bottom: 1px solid #ececec;

      .tab-title-pinlei {
        font-weight: bold;
        color: #666666;
      }

      .tabItem {
        padding-left: 32px;
        box-sizing: border-box;
        font-weight: 400;
        color: rgba(102, 102, 102, 0.8);
        display: flex;
        cursor: pointer;

        &.active {
          font-weight: bold;
          color: #4870ff;
        }
      }

      .tabItem:hover {
        font-weight: bold;
        color: #4870ff;
      }

      .tabItem:focus {
        font-weight: bold;
        color: #4870ff;
      }
    }
  }

  .tab-content {
    padding-top: 32px;

    .tab-content-header {
      font-size: 20px;
      font-weight: bold;
      color: #333333;
      padding-bottom: 8px;
    }

    .tab-content-box {
      border: 1px solid #ececec;
      padding: 32px 24px;
      margin-bottom: 16px;
      display: flex;
      justify-content: space-between;
      align-content: center;

      .box-left {
        display: flex;
        align-items: center;

        .tab-content-left {
          width: 120px;
          height: 120px;
        }

        .content-main {
          padding-left: 15px;
          font-size: 14px;
          font-weight: 400;
          line-height: 34px;

          .main-header {
            font-weight: bold;
            color: #333333;
            font-size: 20px;
          }

          .main-sub {
            color: #666666;
            display: flex;

            .main-sub-line {
              margin: 0 16px;
              color: #999999;
              widows: 1px;
            }
          }

          .main-footer {
            color: #7f97ee;
            display: flex;
            align-items: center;

            .main-footer-icon {
              width: 14px;
              height: 14px;
              margin-right: 3px;
            }
          }
        }
      }

      .box-right {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        font-weight: bold;
        color: #ffa42a;
        font-size: 20px;

        .box-right-buy {
          background: #7f97ee;
          border-radius: 2px;
          padding: 10px 40px;
          margin-top: 10px;
          font-weight: 400;
          color: #ffffff;
          font-size: 14px;
          cursor: pointer;
          display: flex;
          align-items: center;
          .el-icon-shopping-cart-full {
            font-size: 16px;
            padding-right: 8px;
          }

          .box-right-buy-icon {
            width: 16px;
            height: 15px;
            margin-right: 8px;
          }
        }
      }
    }
  }

  /deep/ {
    .el-form-item {
      margin-right: 0;
      margin-bottom: 0;

      &:first-child {
        margin-right: 40px;
      }

      &:last-child {
        margin-left: 20px;
      }
    }

    .el-form-item__label {
      padding: 0 10px 0 0;
      font-size: 14px;
      font-weight: 400;
      color: #333;
    }

    .el-input__inner {
      width: 462px;
      height: 38px;
      line-height: 38px;
      background-color: #fff;
      border: 1px solid #eaeaea;
      border-radius: 2px;

      &:hover {
        border: 1px solid #7996f5;
      }
    }

    .el-table {
      font-size: 14px;
      font-weight: 400;
      color: #333;
    }

    .el-table th {
      height: 40px;
      font-weight: 400;
      color: #666;
      background: #f5f7fa;
    }

    .el-table th.is-leaf {
      border-bottom: transparent;
    }

    .el-table tbody td {
      border-bottom: 1px solid #eaeaea;
    }

    .el-table--enable-row-hover .el-table__body tr:hover > td {
      font-size: 14px;
      color: #121212;
      background: #f7fafd;
      transition: all 0.2s;
    }
  }
}

/deep/.el-dialog__body {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  padding: 54px 0 69px 0;
  border-top: 1px solid #ececec;
  border-bottom: 1px solid #ececec;

  .dialog-content {
    display: flex;
    align-items: center;
    padding-bottom: 12px;

    .dialog-img {
      width: 24px;
      height: 24px;
    }

    .dialog-title {
      font-weight: 400;
      color: #333333;
      font-size: 16px;
      padding-left: 12px;
    }
  }

  .dialog-tel {
    font-weight: 400;
    color: #7f97ee;
    font-size: 20px;
  }

  .dialog-line {
    height: 64px;
  }
}

/deep/ .el-dialog__header {
  font-weight: bold;
  color: #333333;
  font-size: 16px;
  padding: 17px 24px;
}

/deep/.el-dialog__headerbtn .el-dialog__close {
  font-size: 20px;
}

/deep/ .el-dialog__footer {
  padding: 12px 24px;
}

/deep/ .el-button {
  border-radius: 2px;
  padding: 9px 28px;
}
</style>
